/*
 * @name: 训练须知、园区服务建议
 * @
 * @Author: 黄晓玲
 * @Date: 2022-11-30 11:39:51
 * @LastEditors: 黄晓玲
 * @LastEditTime: 2023-02-10 16:59:25
 * @Description: 描述
 */
<template>
  <div>
    <div v-if="list.length === 1 && [3011].includes(+type || +pathName)">
      <div>
        <img
          class="mainBackImg"
          :src="
            language === 'zh'
              ? require('@/assets/images/pilotService/trainBackImg.jpg')
              : require('@/assets/images/pilotService/en_trainBackImg.jpg')
          "
        />
      </div>
      <div class="bread">
        <el-row :gutter="0" type="flex" justify="center">
          <el-col :xs="24" :sm="21" :md="16">
            <slot name="breadcrumb"></slot>
          </el-col>
        </el-row>
      </div>
    </div>
    <div :class="+typeName === 2 ? '' : !!type || isShowimg ? '' : 'container'">
      <div v-if="!isShowimg">
        <articleCenterDetail
          v-if="list.length === 1"
          :id="list[0].id"
          :typeData="typeName"
          ref="articleCenterDetail"
        ></articleCenterDetail>
        <el-row
          v-else
          :gutter="0"
          type="flex"
          justify="center"
          :class="+typeName === 2 ? 'padding_tb20' : ''"
        >
          <el-col
            :xs="+typeName === 2 ? 24 : 24"
            :sm="+typeName === 2 ? 24 : 21"
            :md="+typeName === 2 ? 24 : 16"
          >
            <el-card
              v-for="(item, index) in list"
              :key="index"
              class="contentBox"
            >
              <div class="artic_card" @click="navgateTo(item.id)">
                <img
                  class="artic_img"
                  src="@/assets/images/pilotService/chakan.png"
                />
                <div class="artic_title">{{ item.title }}</div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <!-- 我们的客户\合作伙伴\企业荣誉 -->
      <div class="padding_tb20">
        <el-row v-if="isShowimg" :gutter="0">
          <el-col
            :xs="+typeName === 2 ? 24 : 22"
            :sm="+typeName === 2 ? 24 : 22"
            :md="+typeName === 2 ? 24 : 18"
          >
            <el-row
              :gutter="[3006].includes(+type || +pathName) ? 25 : 10"
              style="display: flex; flex-wrap: wrap; justify-content: left"
            >
              <el-col
                :xs="[3006].includes(+type || +pathName) ? 12 : 8"
                :sm="[3006].includes(+type || +pathName) ? 8 : 6"
                :md="[3006].includes(+type || +pathName) ? 8 : 6"
                v-for="(item, index) in list"
                :key="index"
              >
                <a :href="item.partner_url" target="_blank">
                  <el-image
                    :class="
                      [3006].includes(+type || +pathName)
                        ? 'partnersImgs'
                        : 'partnersImg'
                    "
                    lazy
                    :src="item.pic"
                  >
                  </el-image>
                  <div
                    v-if="[3006].includes(+type || +pathName)"
                    class="partners_title"
                    style="-webkit-box-orient: vertical"
                  >
                    <b>{{ item.title }}</b>
                  </div>
                </a>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <!-- 暂无数据 -->
      <el-row :gutter="0" type="flex" justify="center">
        <el-col
          :xs="24"
          :sm="+typeData === 2 ? 24 : 21"
          :md="+typeData === 2 ? 24 : 16"
        >
          <div v-if="list.length === 0" class="noData">暂无数据</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import * as acticleApi from "@/api/acticle/acticle";
import { routeName } from "@/utils/index";
import articleCenterDetail from "@/views/pilotService/articleCenter/articleCenterDetail";
import { localStorage } from "../../../utils/storage";
export default {
  components: { articleCenterDetail },
  props: {
    type: {
      type: [String, Number],
      default: "",
    },
    typeName: {
      type: [String, Number],
      default: 1,
    },
  },
  data() {
    return {
      language: localStorage.get("language") || "zh",
      list: [],
      pathName: "",
      typeData: {
        3000: { id: 3000, name: "news", title: "公司新闻" },
        3001: { id: 3001, name: "party_building", title: "行业动态" },
        3003: { id: 3003, name: "company_introduce", title: "公司介绍" },
        3004: { id: 3004, name: "company_introduce_detail", title: "公司介绍" },
        3005: { id: 3005, name: "company_culture", title: "企业文化" },
        3006: { id: 3006, name: "company_honor", title: "公司荣誉" },
        3007: { id: 3007, name: "company_history", title: "发展历程" },
        3008: { id: 3008, name: "customer_manager", title: "我们的客户" },
        3009: { id: 3009, name: "partner_manager", title: "合作伙伴" },
        3010: { id: 3010, name: "nanhang_introduce", title: "南航集团介绍" },
        3011: { id: 3011, name: "training_instruction", title: "训练须知" },
        3012: { id: 3012, name: "service_manager", title: "园区服务建议" },
        3013: { id: 3013, name: "organiz_manager", title: "组织架构" },
        3014: {
          id: 3014,
          name: "infomation_publish_manager",
          title: "信息公开",
        },
        4000: { id: 4000, name: "product_show", title: "产品信息" },
        4001: { id: 4001, name: "product_type", title: "理论培训" },
        4002: { id: 4002, name: "product_type", title: "模拟机培训" },
      },
      isShowimg: false,
    };
  },
  created() {
    this.setRouteName();
  },
  watch: {
    $route: "setRouteName",
  },
  methods: {
    setRouteName() {
      const pathName = routeName(this.$route.path);
      this.pathName = pathName;
      this.isShowimg = [3008, 3009, 3006].includes(
        +this.type || +this.pathName
      );
      this.load();
    },
    load() {
      this.list = [];
      acticleApi.getIndex({ id: this.type || this.pathName }).then((res) => {
        this.list = res.data.data;
      });
    },
    navgateTo(id) {
      this.$router.push(`/pilotService/articleCenterDetail/${id}`);
    },
  },
};
</script>

<style scoped>
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.mainBackImg {
  width: 100%;
  /* height: 300px; */
}
.padding_tb20 {
  padding: 20px 0;
}
.container {
  padding: 20px;
}
.contentBox {
  margin: auto;
  position: relative;
  margin-bottom: 25px;
}
.artic_card {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.artic_img {
  width: 24px;
  height: 24px;
  box-sizing: border-box;
}
.artic_title {
  padding: 0px 10px 0px 10px;
  font-weight: 900;
  color: #333333;
  text-align: left;
  line-height: normal;
}
.noData {
  opacity: 0.5;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  line-height: 10;
}
/* 企业荣誉 */
.partnersImgs {
  width: 100%;
  border-radius: 8px;
}
/* 合作伙伴 */
.partnersImg {
  width: 100%;
  height: 93px;
  margin: 5px 0;
  border: 1px solid #dcdfe6;
  /* cursor: pointer; */
}
.partners_title {
  color: #333333;
  text-align: center;
  word-break: break-all;
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 8px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@media only screen and (max-width: 768px) {
  .box {
    width: 100%;
  }
  .contain {
    padding: 10px;
  }
  .title {
    font-size: 17px;
  }
  .partnersImg {
    height: 60px;
  }
}
</style>